import { CatalogoSearchParams } from '../../type/filter'
import { CatalogResponse } from './types'
import { apiCall } from '../../../../common/api/api'
import { UserState } from '../../../../common/context/reducers/userReducer'

export function getCatalogData<T>(
  catalogKey: string,
  data: CatalogoSearchParams<T> & { userInfo?: UserState; cupones?: string[] }
): Promise<CatalogResponse<T>> {
  const url = `${process.env.GATSBY_API_URL}/${catalogKey}/search`
  const queryParams = new URLSearchParams({
    filters: JSON.stringify(data.filters),
    pagination: JSON.stringify(data.pagination),
    order: JSON.stringify(data.order),
    ...(data.userInfo ? { userInfo: JSON.stringify(data.userInfo) } : {}),
    ...(data.cupones?.length ? { cupones: JSON.stringify(data.cupones) } : {}),
  })

  return apiCall(`${url}?${queryParams.toString()}`, {
    method: 'GET',
    auth: true,
  })
}
